export const investmentObjectives = ["preservation", "income", "trading", "growth", "speculation", "hedging"] as const;
export type InvestmentObjective = typeof investmentObjectives[number];
